"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = require("../store/Store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.folderTableSelector = {
    folderTable: function () { return Store_1.default.folders.folderTable; },
};
/** Returns true if a folder is specified distinguished folder. */
function isDistinguishedFolder(folder, distinguishedFolderId) {
    // folder is null in search scenario
    return !!folder && folder.distinguishedFolderId == distinguishedFolderId;
}
exports.isDistinguishedFolder = isDistinguishedFolder;
/** Returns true if a folder is a subfolder of a specified distinguished folder. */
function isSubFolderOfDistinguishedFolder(folder, distinguishedFolderId, state) {
    // folder is null in search scenario
    var parentFolderId = !!folder && folder.ParentFolderId;
    if (!parentFolderId) {
        // The parentFolderId is null for msgfolderroot, which means it's not a subfolder
        return false;
    }
    var parentFolder = state.folderTable.get(parentFolderId.Id);
    while (parentFolder) {
        if (parentFolder.distinguishedFolderId == distinguishedFolderId) {
            return true;
        }
        else if (!parentFolder.ParentFolderId) {
            return false;
        }
        parentFolder = state.folderTable.get(parentFolder.ParentFolderId.Id);
    }
    return false;
}
exports.isSubFolderOfDistinguishedFolder = isSubFolderOfDistinguishedFolder;
exports.isUnderDistinguishedFolder = legacy_1.select({
    folderTable: function () { return Store_1.default.folders.folderTable; },
})(isSubFolderOfDistinguishedFolder);
/** Returns true if a folder is a specified distinguished folder or is a subfolder of it.*/
exports.default = legacy_1.select({
    folderTable: function () { return Store_1.default.folders.folderTable; },
})(function isFolderOrSubFolderOfDistinguishedFolder(folder, distinguishedFolderId, state) {
    return (isDistinguishedFolder(folder, distinguishedFolderId) ||
        exports.isUnderDistinguishedFolder(folder, distinguishedFolderId, state));
});
//# sourceMappingURL=isFolderOrSubFolderOfDistinguishedFolder.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-store/lib/utils/isFolderOrSubFolderOfDistinguishedFolder.js
// module id = 2226
// module chunks = 23 62 105